export default {
  // 当被绑定的元素插入到 DOM 中时……
  mounted: (el, binding) => {
    // 指令绑定值(或者指令参数)
    const value = binding.value || binding.arg
    // 获取用户全部权限
    const auths = JSON.parse(localStorage.getItem('permissions') || '[]')
    // 判定是否有权限，没有删除节点，即不显示相关权限内容
    if (Array.isArray(value)) {
      if (!auths.some((auth) => value.includes(auth))) {
        if (el.parentNode) {
          el.parentNode.removeChild(el)
        }
      }
    } else {
      if (!auths.includes(value)) {
        if (el.parentNode) {
          el.parentNode.removeChild(el)
        }
      }
    }
  },
}
